module.exports = __webpack_public_path__ + "static/media/food-memory-game.4601ab6f.png";